import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import useDisplay from "../../hooks/useDisplay";
import styled from "styled-components";
import PCContainer from "../../components/atoms/layout/pcContainer";
import LSRgDisplay02 from "./../../components/molecules/text/linSeedKr/Rg/lsRgDisplay02";
import { route } from "../../router/route";
import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import LSRgBody01 from "../../components/molecules/text/linSeedKr/Rg/lsRgBody01";
import Pagination from "./../../components/molecules/pagination";
import { classroomSubTabList, tabList } from "./../../constant/myPageTab";
import LSBdH2HeadLine from "../../components/molecules/text/linSeedKr/Bd/lsBdH2HeadLine";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import LSRgCaption02 from "../../components/molecules/text/linSeedKr/Rg/lsRgCaption02";
import SelectBox from "../../components/organisms/SelectBox";
import MOContainer from "../../components/atoms/layout/moContainer";
import LSBdCaption03 from "../../components/molecules/text/linSeedKr/Bd/lsBdCaption03";
import LSBdBody01 from "../../components/molecules/text/linSeedKr/Bd/lsBdBody01";
import LectureApi from "../../api/lecture.api";
import { fileUrl } from "../../api/api";
import moment from "moment";
import Empty from "./../../components/molecules/empty";
import { macOSCheck } from "../../util/macOSCheck";
import StyledCategoryItem from "../../components/molecules/button/styledCategoryItem";
import StyledSubCategoryItem from "../../components/molecules/button/styledSubCategoryItem";
import Loading from "../../components/templates/loading";
import { errorHandler } from "../../util/errorHandler";
import { toast } from "react-toastify";

const MyPageClassroomComplete = () => {
  const navigate = useNavigate();
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;
  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line
  const location = useLocation();

  // ---------- 모바일 버전 탭 관련 ---------- //
  const [subMenuBoxOpen, setSubMenuBoxOpen] = useState(false);
  const [selectedSubMenu, setSelectedSubMenu] = useState(tabList[2].title);

  const [selectedSubMenuTabOpen, setSelectedSubMenuTabOpen] = useState(false);
  const [selectedSubMenuTab, setSelectedSubMenuTab] = useState(
    classroomSubTabList[1].title,
  );

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    if (sessionStorage.getItem("isLogin") !== "true") {
      toast("로그인이 필요한 서비스입니다.");
      navigate(
        `${route.login}?returnUrl=${encodeURIComponent(
          route.my_page_classroom_complete,
        )}`,
        { replace: true },
      );
      return;
    }

    getLectureList();
  }, [location]); // eslint-disable-line

  // ---------- 카테고리 관련 ---------- //
  const categoryList = [
    { title: "전체", value: "ALL" },
    { title: "스터디", value: "FINANCE_STUDY" },
    { title: "강의", value: "PAID_LECTURE" },
    { title: "컨설팅", value: "CONSULTING" },
  ];

  const category = useMemo(() => {
    const requestedCategory = searchParams.get("category") || "ALL";
    return categoryList.some((item) => item.value === requestedCategory)
      ? requestedCategory
      : "ALL";
  }, [searchParams]);

  // ---------- 페이지네이션 관련 ---------- //
  const page = useMemo(() => {
    const requestedPage = Number(searchParams.get("page"));
    return Number.isInteger(requestedPage) && requestedPage > 0
      ? requestedPage
      : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 6, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 1,
  });

  // ---------- 게시물 리스트 가져오기 ---------- //
  const [lectureList, setLectureList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getLectureList = async () => {
    if (sessionStorage.getItem("isLogin") !== "true") return;

    try {
      setIsLoading(true);
      const data = {
        page: page || 1,
        size: pagination.size,
        activation: "Active",
        memberLectureStatus: "COMPLETE",
      };

      if (category === "CONSULTING") {
        data.lectureVideoFlag = "Inactive";
      } else if (category === "FINANCE_STUDY" || category === "PAID_LECTURE") {
        data.lectureCategoryType = category;
      }

      const response = (await LectureApi.getMemberList(data)).data.data;

      setLectureList(response?.content ?? []);

      setPagination((prev) => ({
        ...prev,
        totalCount: response.totalCount,
        totalPages:
          response.totalPage ||
          Math.max(1, Math.ceil(response.totalCount / prev.size)),
      }));
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <HomeSection $isSmall={isSmall}>
      {isDesktop && (
        <PCContainer
          style={{
            flexDirection: "column",
            width: "100%",
            padding: isSmall ? "0px 20px" : "0px",
          }}
        >
          <LSRgDisplay02
            style={{
              color: "#000",
              marginBottom: 32,
            }}
          >
            👨‍💻 마이페이지
          </LSRgDisplay02>
          <div
            style={{
              display: "flex",
              width: "100%",
              height: "fit-content",
              gap: 30,
            }}
          >
            {/* 탭 영역 */}
            <TabContainer>
              {tabList.map((tab, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 16,
                  }}
                >
                  <StyledCategoryItem
                    onClick={() => navigate(tab.path)}
                    isActive={index === 2 ? true : false}
                    title={tab.title}
                  />

                  {index === 2 && (
                    <SubTabWrapper>
                      {classroomSubTabList.map((subTab, index) => (
                        <StyledSubCategoryItem
                          key={index}
                          onClick={() => {
                            navigate(subTab.path);
                          }}
                          title={subTab.title}
                          isActive={index === 1 ? true : false}
                        />
                      ))}
                    </SubTabWrapper>
                  )}
                </div>
              ))}
            </TabContainer>
            {/* 본문 영역 */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 30,
              }}
            >
              <ContentContainer>
                <ContentHeaderWrapper>
                  <LSRgDisplay02 style={{ color: "#000" }}>
                    수강 완료 강의
                  </LSRgDisplay02>
                  <ContentHeaderTabWrapper>
                    {categoryList.map((item, index) => (
                      <ContentHeaderTab
                        key={index}
                        isActive={category === item.value ? true : false}
                        onClick={() => {
                          navigate(
                            `${route.my_page_classroom_complete}?category=${item.value}`,
                          );
                        }}
                      >
                        <LSRgBody01
                          style={{
                            color: category === item.value ? "#fff" : "#A4A8B1",
                            marginTop: macOSCheck() ? 0 : 2,
                          }}
                        >
                          {item?.title || ""}
                        </LSRgBody01>
                      </ContentHeaderTab>
                    ))}
                  </ContentHeaderTabWrapper>
                </ContentHeaderWrapper>

                {/* 본문 영역 - 강의 리스트 */}
                <ContentBodyWrapper>
                  {isLoading ? (
                    <Loading />
                  ) : lectureList.length > 0 ? (
                    <>
                      {lectureList.map((item, index) => (
                        <LectureWrapper
                          key={item.id}
                          disabled={item.memberLectureStatus === "END"}
                        >
                          {item?.lectureVideoFlag ? (
                            <div
                              style={{
                                width: 111,
                                height: 111,
                                marginRight: 50,
                              }}
                            >
                              <CircularProgressbar
                                value={item?.progressPercent || 0}
                                text={`${item?.progressPercent || 0}%`}
                                strokeWidth={10}
                                counterClockwise={true}
                                styles={buildStyles({
                                  pathColor:
                                    item.memberLectureStatus === "END"
                                      ? "#C0C2C8"
                                      : "#5050FF", // 진행 색상 설정
                                  textColor:
                                    item.memberLectureStatus === "END"
                                      ? "#C0C2C8"
                                      : "#5050FF", // 텍스트 색상 설정
                                  trailColor:
                                    item.memberLectureStatus === "END"
                                      ? "#C0C2C8"
                                      : "#DBDDE0", // 비진행 색상 설정
                                  strokeLinecap: "butt", // 끝을 직선으로 설정
                                })}
                              />
                            </div>
                          ) : null}

                          <LectureContentImg
                            src={
                              item?.lecture?.thumbnailServerFileName
                                ? `${fileUrl}/${item?.lecture?.thumbnailServerFileName}`
                                : ""
                            }
                            alt="강의 썸네일"
                          />

                          <LectureTextWrapper>
                            <LSBdH2HeadLine
                              style={{
                                color:
                                  item.memberLectureStatus === "END"
                                    ? "#A4A8B1"
                                    : "#000",
                              }}
                            >
                              {item?.lecture?.title || ""}
                            </LSBdH2HeadLine>
                            {item?.lectureVideoFlag ? (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 20,
                                }}
                              >
                                <LSRgH1HeadLine
                                  style={{
                                    color:
                                      item.memberLectureStatus === "END"
                                        ? "#A4A8B1"
                                        : "#000",
                                  }}
                                >
                                  수강 기간
                                </LSRgH1HeadLine>
                                <LSRgH1HeadLine
                                  style={{
                                    color:
                                      item.memberLectureStatus === "END"
                                        ? "#A4A8B1"
                                        : "#000",
                                  }}
                                >
                                  {item.endDate
                                    ? `${moment(item.startDate).format(
                                        "YYYY.MM.DD",
                                      )} ~ ${moment(item.endDate).format(
                                        "YYYY.MM.DD",
                                      )}`
                                    : "무제한"}
                                </LSRgH1HeadLine>
                              </div>
                            ) : null}
                          </LectureTextWrapper>

                          {item?.lectureVideoFlag ? null : (
                            <div
                              style={{
                                width: 161,
                              }}
                            />
                          )}

                          <LectureBtnWrapper>
                            {item?.lectureVideoFlag ? (
                              <LectureBtn
                                isLectureView={true}
                                disabled={item.memberLectureStatus === "END"}
                                onClick={() => {
                                  navigate(
                                    `${route.my_page_classroom_lecture}/${item.id}/${item.lecture.id}`,
                                  );
                                }}
                              >
                                <LSRgH1HeadLine
                                  style={{
                                    marginTop: macOSCheck() ? 0 : 2,
                                    color:
                                      item.memberLectureStatus === "END"
                                        ? "#898E99"
                                        : "#5050FF",
                                  }}
                                >
                                  강의 보기
                                </LSRgH1HeadLine>
                              </LectureBtn>
                            ) : null}

                            <LectureBtn
                              isReviewWrote={item?.reviewFlag || false}
                              onClick={() => {
                                if (item.reviewFlag) {
                                  return;
                                }

                                navigate(
                                  `${route.my_page_classroom_review}/${item.id}/${item.lecture.id}`,
                                  {
                                    state: {
                                      isConsulting: item?.lectureVideoFlag
                                        ? false
                                        : true,
                                    },
                                  },
                                );
                              }}
                            >
                              <LSRgH1HeadLine
                                style={{ marginTop: 2, color: "#898E99" }}
                              >
                                {item.reviewFlag
                                  ? "후기 작성 완료"
                                  : "후기 작성"}
                              </LSRgH1HeadLine>
                            </LectureBtn>
                          </LectureBtnWrapper>
                        </LectureWrapper>
                      ))}
                    </>
                  ) : (
                    <Empty title={"등록된 강의가 없습니다."} />
                  )}
                </ContentBodyWrapper>

                {lectureList.length > 0 &&
                  pagination.totalCount > pagination.size && (
                    <Pagination
                      route={route.my_page_classroom_complete}
                      queryString={`${
                        searchParams.get("category")
                          ? "&category=" + searchParams.get("category")
                          : ""
                      }`}
                      currentPage={Number(page) || 1}
                      totalPages={pagination.totalPages}
                      rangeSize={pagination.rangeSize}
                    />
                  )}
              </ContentContainer>
            </div>
          </div>
        </PCContainer>
      )}

      {/* ******************************** */}
      {/* ********** 모바일 버전 ********** */}
      {/* ******************************** */}
      {isSmall && (
        <MOContainer>
          <ContentContainer $isSmall={isSmall}>
            <ContentHeaderWrapper $isSmall={isSmall}>
              <LSRgH1HeadLine>👨‍💻 마이페이지</LSRgH1HeadLine>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <SelectBox
                  style={{ width: 158 }}
                  subMenuStyle={{ width: 158 }}
                  isSmall={true}
                  isOpen={subMenuBoxOpen}
                  isLink={true}
                  selectedValue={selectedSubMenu}
                  wrapperHandler={() => {
                    setSubMenuBoxOpen(!subMenuBoxOpen);
                  }}
                  itemList={tabList}
                  selectedValueSetterFunc={setSelectedSubMenu}
                />

                <SelectBox
                  style={{ width: 158 }}
                  subMenuStyle={{ width: 158 }}
                  isSmall={true}
                  isOpen={selectedSubMenuTabOpen}
                  isLink={true}
                  selectedValue={selectedSubMenuTab}
                  wrapperHandler={() => {
                    setSelectedSubMenuTabOpen(!selectedSubMenuTabOpen);
                  }}
                  itemList={classroomSubTabList}
                  selectedValueSetterFunc={setSelectedSubMenuTab}
                />
              </div>
            </ContentHeaderWrapper>

            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                marginBottom: 20,
              }}
            >
              <LSRgH1HeadLine>수강 완료 강의</LSRgH1HeadLine>

              <ContentHeaderTabWrapper $isSmall={isSmall}>
                {categoryList.map((item, index) => (
                  <ContentHeaderTab
                    style={{
                      marginTop: 12,
                    }}
                    $isSmall={isSmall}
                    key={index}
                    isActive={category === item.value ? true : false}
                    onClick={() => {
                      navigate(
                        `${route.my_page_classroom_complete}?category=${item.value}`,
                      );
                    }}
                  >
                    <LSRgCaption02
                      style={{
                        color: category === item.value ? "#fff" : "#A4A8B1",
                        marginTop: macOSCheck() ? 0 : 2,
                      }}
                    >
                      {item?.title || ""}
                    </LSRgCaption02>
                  </ContentHeaderTab>
                ))}
              </ContentHeaderTabWrapper>
            </div>

            {/* 본문 영역 - 강의 리스트 */}
            <ContentBodyWrapper $isSmall={isSmall}>
              {isLoading ? (
                <Loading />
              ) : lectureList.length > 0 ? (
                <>
                  {lectureList.map((item, index) => (
                    <LectureWrapper
                      key={item.id}
                      disabled={item.memberLectureStatus === "END"}
                      $isSmall={isSmall}
                    >
                      {item?.lectureVideoFlag ? (
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                            marginBottom: 18,
                          }}
                        >
                          <div style={{ width: 24, height: 24 }}>
                            <CircularProgressbar
                              value={item?.progressPercent || 0}
                              // text={`${item?.progressPercent || 0}%`}
                              strokeWidth={10}
                              counterClockwise={true}
                              styles={buildStyles({
                                pathColor:
                                  item.memberLectureStatus === "END"
                                    ? "#C0C2C8"
                                    : "#5050FF", // 진행 색상 설정
                                trailColor:
                                  item.memberLectureStatus === "END"
                                    ? "#C0C2C8"
                                    : "#DBDDE0", // 비진행 색상 설정
                                strokeLinecap: "butt", // 끝을 직선으로 설정
                              })}
                            />
                          </div>
                          <LSBdCaption03
                            style={{
                              color:
                                item.memberLectureStatus === "END"
                                  ? "#C0C2C8"
                                  : "#5050FF",
                            }}
                          >
                            {item?.progressPercent || 0}% 수강
                          </LSBdCaption03>
                        </div>
                      ) : null}

                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          gap: 15,
                        }}
                      >
                        <LectureContentImg
                          $isSmall={isSmall}
                          src={
                            item?.lecture?.thumbnailServerFileName
                              ? `${fileUrl}/${item?.lecture?.thumbnailServerFileName}`
                              : ""
                          }
                          alt="강의 썸네일"
                        />
                        <LectureTextWrapper $isSmall={isSmall}>
                          <LSBdBody01
                            style={{
                              color:
                                item.memberLectureStatus === "END"
                                  ? "#A4A8B1"
                                  : "#000",
                            }}
                          >
                            {item?.lecture?.title || ""}
                          </LSBdBody01>
                          {item?.lectureVideoFlag ? (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 20,
                              }}
                            >
                              <LSRgCaption02
                                style={{
                                  color:
                                    item.memberLectureStatus === "END"
                                      ? "#A4A8B1"
                                      : "#000",
                                }}
                              >
                                수강 기간
                              </LSRgCaption02>
                              <LSRgCaption02
                                style={{
                                  color:
                                    item.memberLectureStatus === "END"
                                      ? "#A4A8B1"
                                      : "#000",
                                }}
                              >
                                {item.endDate
                                  ? `${moment(item.startDate).format(
                                      "YYYY.MM.DD",
                                    )} ~ ${moment(item.endDate).format(
                                      "YYYY.MM.DD",
                                    )}`
                                  : "무제한"}
                              </LSRgCaption02>
                            </div>
                          ) : null}
                        </LectureTextWrapper>
                      </div>

                      <LectureBtnWrapper $isSmall={isSmall}>
                        {item?.lectureVideoFlag ? (
                          <LectureBtn
                            $isSmall={isSmall}
                            isLectureView={true}
                            disabled={item.memberLectureStatus === "END"}
                            onClick={() => {
                              navigate(
                                `${route.my_page_classroom_lecture}/${item.id}/${item.lecture.id}`,
                              );
                            }}
                          >
                            <LSRgH1HeadLine
                              style={{
                                marginTop: macOSCheck() ? 0 : 2,
                                color:
                                  item.memberLectureStatus === "END"
                                    ? "#898E99"
                                    : "#5050FF",
                              }}
                            >
                              강의 보기
                            </LSRgH1HeadLine>
                          </LectureBtn>
                        ) : null}
                        <LectureBtn
                          $isSmall={isSmall}
                          style={{
                            width: item?.lectureVideoFlag ? 140 : 295,
                          }}
                          isReviewWrote={item?.reviewFlag || false}
                          onClick={() => {
                            if (item.reviewFlag) {
                              return;
                            }

                            navigate(
                              `${route.my_page_classroom_review}/${item.id}/${item.lecture.id}`,
                              {
                                state: {
                                  isConsulting: item?.lectureVideoFlag
                                    ? false
                                    : true,
                                },
                              },
                            );
                          }}
                        >
                          <LSRgH1HeadLine
                            style={{ marginTop: 2, color: "#898E99" }}
                          >
                            {item.reviewFlag ? "후기 작성 완료" : "후기 작성"}
                          </LSRgH1HeadLine>
                        </LectureBtn>
                      </LectureBtnWrapper>
                    </LectureWrapper>
                  ))}
                </>
              ) : (
                <Empty title={"등록된 강의가 없습니다."} />
              )}
            </ContentBodyWrapper>

            {lectureList.length > 0 &&
              pagination.totalCount > pagination.size && (
                <Pagination
                  route={route.my_page_classroom_complete}
                  queryString={`${
                    searchParams.get("category")
                      ? "&category=" + searchParams.get("category")
                      : ""
                  }`}
                  currentPage={Number(page) || 1}
                  totalPages={pagination.totalPages}
                  rangeSize={pagination.rangeSize}
                />
              )}
          </ContentContainer>
        </MOContainer>
      )}
    </HomeSection>
  );
};

export default MyPageClassroomComplete;

const HomeSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: ${(props) =>
    props.$isSmall ? "40px 0px 80px 0px" : "80px 0px 150px 0px"};
`;

const TabContainer = styled.div.attrs((props) => {})`
  width: 175px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const SubTabWrapper = styled.div.attrs((props) => {})`
  width: 175px;
  height: fit-content;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: -6px;
`;

const ContentContainer = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  height: fit-content;
  display: flex;
  flex-direction: column;
`;

const ContentHeaderWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: ${(props) => (props.$isSmall ? "stretch" : "center")};
  justify-content: space-between;
  flex-direction: ${(props) => (props.$isSmall ? "column" : "row")};
  gap: ${(props) => (props.$isSmall ? "16px" : "0px")};
  margin-bottom: ${(props) => (props.$isSmall ? "40px" : "30px")};
`;

const ContentHeaderTabWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: ${(props) => (props.$isSmall ? "6px" : "10px")};
`;

const ContentHeaderTab = styled.button.attrs((props) => {})`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  height: ${(props) => (props.$isSmall ? "22px" : "36px;")};
  padding: ${(props) => (props.$isSmall ? "0px 14px" : "8px 14px;")};
  border-radius: 8px;
  border: ${(props) => !props.isActive && "1px solid #A4A8B1"};
  background-color: ${(props) => (props.isActive ? "#5050FF" : "#fff")};
`;

const ContentBodyWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.$isSmall ? "15px" : "20px")};
`;

const LectureWrapper = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  display: flex;
  flex-direction: ${(props) => (props.$isSmall ? "column" : "row")};
  align-items: ${(props) => (props.$isSmall ? "flex-start" : "center")};
  padding: ${(props) => (props.$isSmall ? "30px 20px" : "40px")};
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);
  background-color: ${(props) => (props.disabled ? "#F6F7F8" : "#fff")};
  border-radius: 20px;
`;

const LectureContentImg = styled.img.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "100px" : "175px")};
  height: ${(props) => (props.$isSmall ? "62px" : "111px")};
  object-fit: cover;
  border-radius: ${(props) => (props.$isSmall ? "8px" : "15px")};
`;

const LectureTextWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.$isSmall ? "10px" : "20px")};
  width: ${(props) => (props.$isSmall ? "180px" : "332px")};
  margin-left: ${(props) => (props.$isSmall ? "0px" : "30px")};
`;

const LectureBtnWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: ${(props) => (props.$isSmall ? "row" : "column")};
  gap: 15px;
  margin-left: ${(props) => (props.$isSmall ? "0px" : "42px")};
  margin-top: ${(props) => (props.$isSmall ? "20px" : "0px")};
`;

const LectureBtn = styled.button.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "140px" : "175px")};
  height: 46px;
  border: ${(props) =>
    props.isLectureView && props.disabled
      ? ""
      : props.isLectureView && !props.disabled
        ? "1px solid #5050FF"
        : "1px solid #898E99"};
  border-radius: 15px;
  background-color: ${(props) => props.disabled && "#DBDDE0"};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${(props) =>
    props.disabled || props.isReviewWrote ? "not-allowed" : "pointer"};
`;
